import fetch from 'isomorphic-fetch';
import _ from 'lodash'; // eslint-disable-line


export const ActionTypes = {
  REQUEST_PROJECT: 'zola/cards/card_project/REQUEST_PROJECT',
  RECEIVE_PROJECT: 'zola/cards/card_project/RECEIVE_PROJECT',
  REQUEST_CUSTOMIZATION: 'zola/card/card_project/REQUEST_CUSTOMIZATION',
  RECEIVE_CUSTOMIZATION: 'zola/card/card_project/RECEIVE_CUSTOMIZATION',
  RECEIVE_SKU: 'zola/card/card_project/RECEIVE_SKU',
  SET_ACTIVE_FIELD: 'zola/card/card_project/SET_ACTIVE_FIELD',
  RECEIVE_CUSTOMIZATION_DISABLED: 'zola/card/card_project/RECEIVE_CUSTOMIZATION_DISABLED',
  RECEIVE_DELETE_ELEMENT_IMAGE: 'zola/card/card_project/RECEIVE_DELETE_ELEMENT_IMAGE',
  SET_PROJECT_QUANTITY: 'zola/card/card_project/SET_PROJECT_QUANTITY',
  REQUEST_DRAFTS: 'zola/card/card_project/REQUEST_DRAFTS',
  RECEIVE_DRAFTS: 'zola/card/card_project/RECEIVE_DRAFTS',
  REQUEST_ORDERS: 'zola/card/card_project/REQUEST_ORDERS',
  RECEIVE_ORDERS: 'zola/card/card_project/RECEIVE_ORDERS',
  RECEIVE_CANCELED_ORDER: 'zola/card/card_project/RECEIVE_CANCELED_ORDER',
  REQUEST_PROJECT_GUEST_IDS: 'zola/card/card_project/guests/REQUEST_PROJECT_GUEST_IDS',
  RECEIVE_PROJECT_GUEST_IDS: 'zola/card/card_project/guests/RECEIVE_PROJECT_GUEST_IDS',
  REQUEST_PROJECT_AUTHENTICATION: 'zola/card/card_project/REQUEST_PROJECT_AUTHENTICATION',
  RECEIVE_PROJECT_AUTHENTICATION: 'zola/card/card_project/RECEIVE_PROJECT_AUTHENTICATION'
};

const handleErrors = (response) => {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
};

function requestProject() {
  return {
    type: ActionTypes.REQUEST_PROJECT,
  };
}

function receiveProject(cardProject) {
  return {
    type: ActionTypes.RECEIVE_PROJECT,
    payload: {
      cardProject
    }
  };
}

function requestCustomization() {
  return {
    type: ActionTypes.REQUEST_CUSTOMIZATION
  };
}

function receiveCustomization(customization) {
  return {
    type: ActionTypes.RECEIVE_CUSTOMIZATION,
    payload: {
      customization
    }
  };
}

function receiveSku(sku) {
  return {
    type: ActionTypes.RECEIVE_SKU,
    payload: {
      sku
    }
  };
}

function receiveCustomizationDisabled(uuid) {
  return {
    type: ActionTypes.RECEIVE_CUSTOMIZATION_DISABLED,
    payload: {
      uuid
    }
  };
}

function receiveDeleteElementImage(customizationUUID, elementUUID, element) {
  return {
    type: ActionTypes.RECEIVE_DELETE_ELEMENT_IMAGE,
    payload: {
      customizationUUID,
      elementUUID,
      element
    }
  };
}

function setProjectQuantity(quantity) {
  return {
    type: ActionTypes.SET_PROJECT_QUANTITY,
    payload: {
      quantity
    }
  };
}

function requestDrafts() {
  return {
    type: ActionTypes.REQUEST_DRAFTS
  };
}

function receiveDrafts(drafts) {
  return {
    type: ActionTypes.RECEIVE_DRAFTS,
    payload: {
      drafts
    }
  };
}

function requestCompleted() {
  return {
    type: ActionTypes.REQUEST_ORDERS
  };
}

function receiveCompleted(orders) {
  return {
    type: ActionTypes.RECEIVE_ORDERS,
    payload: {
      orders
    }
  };
}

function receiveCanceledOrder(order) {
  return {
    type: ActionTypes.RECEIVE_CANCELED_ORDER,
    payload: {
      order
    }
  };
}

function requestProjectGuestIds() {
  return {
    type: ActionTypes.REQUEST_PROJECT_GUEST_IDS
  };
}

function receiveProjectGuestIds(projectGuestIds) {
  return {
    type: ActionTypes.RECEIVE_PROJECT_GUEST_IDS,
    payload: {
      projectGuestIds
    }
  };
}

function requestProjectAuthentication() {
  return {
    type: ActionTypes.REQUEST_PROJECT_AUTHENTICATION
  };
}

function receiveProjectAuthentication() {
  return {
    type: ActionTypes.RECEIVE_PROJECT_AUTHENTICATION
  };
}

export function setActiveField(activeField) {
  return {
    type: ActionTypes.SET_ACTIVE_FIELD,
    payload: {
      activeField
    }
  };
}

export function fetchSkuByObjectId(skuObjectId) {
  return dispatch => ( // eslint-disable-line
    fetch(`/web-api/v1/card-product/skus/${skuObjectId}`, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then((json) => {
      // console.log(json);
      dispatch(receiveSku(json));
      return json;
    })
  );
}

export function fetchProject(projectUUID) {
  return (dispatch, getState) => { // eslint-disable-line
    // console.log('fetchProject V2');
    dispatch(requestProject());
    return fetch(`/web-api/v2/card-project/${projectUUID}`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(response => response.json())
    .then((json) => {
      const skus = getState().cards.cardProject.skus;
      json.customizations.forEach((customization) => {
        if (!_.has(skus, customization.sku_object_id)) {
          dispatch(fetchSkuByObjectId(customization.sku_object_id));
        }
      });
      dispatch(receiveProject(json));
      return json;
    });
    // .then((json) => {
    //   json.customization_templates.forEach((customization) => {
    //     dispatch(receiveCustomization(customization));
    //   });
    //   dispatch(receiveProject({ project: json }));
    //   return json;
    // })
  };
}

export function createProject(skuId, quantity) {
  return (dispatch, getState) => {
    const requestBody = {
      sku_object_id: skuId,
      quantity
    };
    return fetch('/web-api/v2/card-project',
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => response.json())
      .then((json) => {
        // json.customization_templates.forEach((customization) => {
        //   dispatch(receiveCustomization(customization));
        // });
        const skus = getState().cards.cardProject.skus;
        json.customizations.forEach((customization) => {
          if (!_.has(skus, customization.sku_object_id)) {
            dispatch(fetchSkuByObjectId(customization.sku_object_id));
          }
        });
        dispatch(receiveProject(json));
        return json;
      });
  };
}

export function cloneProject(projectUUID) { // eslint-disable-line
  return (dispatch) => ( // eslint-disable-line
    fetch(`/web-api/v2/card-project/${projectUUID}/clone`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      // .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        const { uuid } = json;
        return dispatch(fetchProject(uuid));
      })
  );
}

export function fetchCustomization(uuid) {
  return (dispatch, getState) => { // eslint-disable-line
    // console.log('fetch customization v2');
    dispatch(requestCustomization());
    return fetch(`/web-api/v2/card-project/customization/${uuid}`, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then((json) => {
      const skus = getState().cards.cardProject.skus;
      if (!_.has(skus, json.sku_object_id)) {
        dispatch(fetchSkuByObjectId(json.sku_object_id));
      }
      dispatch(receiveCustomization(json));
      return json;
    });
  };
}

export function updateCustomization(customizationUUID, customizationData) { //eslint-disable-line
  return (dispatch) => { // eslint-disable-line
    // TODO: need to add this back in to set flag that an update request is in progress
    // dispatch(requestUpdateCustomization());
    return fetch(`/web-api/v2/card-project/customization/${customizationUUID}`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customizationData)
    })
    .then(response => response.json())
    .then((json) => {
      // console.log('skuObjectId: ', json);
      dispatch(receiveCustomization(json));
      return json;
    });
  };
}

export function migrateCustomization(customizationUUID) {
  // console.log('migrating customization: ', customizationUUID);
  return dispatch => ( // eslint-disable-line
    fetch(`/web-api/v2/card-project/customization/${customizationUUID}/migrate`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ customizationUUID })
    })
    .then(response => response.json())
    .then((json) => {
      // console.log('successfully migrated customization: ', json);
      dispatch(receiveCustomization(json));
      return json;
    })
  );
}

export function deleteElementImage(customizationUUID, elementUUID) {
  return (dispatch) => { // eslint-disable-line
    return fetch(`/web-api/v2/card-project/element/${elementUUID}`, {
      credentials: 'same-origin',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then((json) => {
      // console.log('deleted element image: ', json);
      dispatch(receiveDeleteElementImage(customizationUUID, elementUUID, json));
      return json;
    });
  };
}

export const toggleCustomizationDisabled = (customizationUUID, bool) => {
  // console.log('toggleCustomizationDisabled: ', customizationUUID, bool);
  const requestBody = {
    rsvp_enabled: bool
  };
  return (dispatch, getState) => {
    const { projectUUID } = getState().cards.cardProject;
    fetch(`/web-api/v1/card-project/customization/${projectUUID}/toggle_rsvp`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then((json) => {
      const { deleted } = json;
      if (deleted) {
        dispatch(receiveCustomizationDisabled(customizationUUID));
      } else {
        // const customizationUUID = getState().cards.cardProject.cardTypeToUUID.RSVP;
        dispatch(fetchCustomization(customizationUUID));
      }
    });
  };
};

export const toggleBackCustomization = (customizationUUID, bool) => {
  const toggleBackCustomizationRequest = {
    back_enabled: bool,
  };
  return (dispatch) => {
    fetch(`/web-api/v2/card-project/customization/${customizationUUID}/toggle_back`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toggleBackCustomizationRequest)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const updateLinerColor = (customizationUUID, linerColor) => {
  const requestBody = {
    linerColor
  };
  return (dispatch) => {
    fetch(`/web-api/v2/card-project/customization/${customizationUUID}/update_liner_color`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const toggleMealOptions = (customizationUUID, bool) => {
  const toggleAddMealOptionsRequest = {
    meal_options_enabled: bool
  };
  return (dispatch) => {
    fetch(`/web-api/v2/card-project/customization/${customizationUUID}/toggle_meal_options`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toggleAddMealOptionsRequest)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const toggleRecipientAddressing = (customizationUUID, bool) => (
  (dispatch) => {
    const requestBody = {
      recipient_addressing: bool
    };
    // actually just hits the same endpoint as updateCustomization, just with a request
    // body specific to recipient addressing
    return fetch(`/web-api/v2/card-project/customization/${customizationUUID}`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then(json => dispatch(receiveCustomization(json)));
  }
);

// this hits a v1 endpoint but should be okay for now because the quantity for the
// project is still updated, we no longer care about the response though.
// eventually, there may be a v2 updateProjectQuantity that just returns a 200 OK,
// we then dispatch an action to update the quantity for each customization of the project
export const updateProjectQuantity = (projectUUID, quantity) => { // eslint-disable-line
  return (dispatch) => { // eslint-disable-line
    fetch(`/web-api/v1/card-project/${projectUUID}/quantity`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ quantity })
      })
      // .then(response => response.json()) // no longer needed because we dont care about response
      .then(() => {
        console.log('updating project quantity: ', quantity);
        dispatch(setProjectQuantity(quantity));
      });
  };
};

export const fetchDrafts = () => (
  (dispatch) => {
    dispatch(requestDrafts());
    return fetch('/web-api/v2/card-project/projects/drafts',
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveDrafts(json)));
  }
);

export const fetchOrders = () => (
  (dispatch) => {
    dispatch(requestCompleted());
    return fetch('/web-api/v2/card-project/projects/orders',
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveCompleted(json)));
  }
);

export const deleteProjectDraft = (projectUUID) => { // eslint-disable-line
  return dispatch => ( // eslint-disable-line
    fetch('/web-api/v1/card-project/delete',
      {
        credentials: 'same-origin',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ projectUUID })
      })
      .then(response => response.json())
      .then((json) => { // eslint-disable-line
        // console.log(json);
        return json;
      })
  );
};

// this hits a web-api v1 endpoint, which is not a problem, it works fine. Just
// something to be mindful of as v1 things begin to get deprecated
export const addProjectToCart = (projectUUID) => { // eslint-disable-line
  return dispatch => ( // eslint-disable-line
    fetch('/web-api/v1/card-project/cart',
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ projectUUID })
      })
      .then(handleErrors)
  );
};

export const cancelOrder = (orderUUID) => { // eslint-disable-line
  return dispatch => (
    fetch(`/web-api/v1/card-project/orders/${orderUUID}/cancel`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveCanceledOrder(json)))
  );
};

export const getMediaFileUrl = mediaFileUUID => (
  dispatch => ( // eslint-disable-line
    fetch(`/web-api/v1/card-project/media_file/${mediaFileUUID}/presigned_url`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.text())
  )
);

export const getProjectGuestIds = projectUUID => (
  (dispatch) => {
    dispatch(requestProjectGuestIds());
    return fetch(`/web-api/v1/card-project/${projectUUID}/guests`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveProjectGuestIds(json)));
  }
);

export const updateProjectGuestIds = (projectUUID, projectGuestIds) => (
  (dispatch) => {
    const requestBody = {
      recipients: projectGuestIds
    };
    return fetch(`/web-api/v1/card-project/${projectUUID}/guests`,
      {
        credentials: 'same-origin',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveProjectGuestIds(json)));
  }
);

export const getProjectAuthenticated = projectUUID => (
  (dispatch) => {
    dispatch(requestProjectAuthentication());
    return fetch(`/web-api/v1/card-project/${projectUUID}/is_authenticated`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ projectUUID })
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((auth) => {
        dispatch(receiveProjectAuthentication(auth));
        return auth;
      });
  }
);




/** WEBPACK FOOTER **
 ** ./src/cards/actions/cardProjectActionsV2.js
 **/